import { Header } from './Header';

interface AppShellProps {
  children: React.ReactNode;
}

export function AppShell({ children }: AppShellProps) {
  return (
    <div className="flex h-screen flex-col bg-xtravirt-light">
      {/* Top navigation header */}
      <Header />

      {/* Main content */}
      <main className="flex-1 overflow-auto p-4 md:p-6 lg:p-8">
        <div className="mx-auto max-w-[1400px]">
          {children}
        </div>
      </main>
    </div>
  );
}
